import React from "react";
import PropTypes from "prop-types";
import ShotClock from "../../../../../ShotClock/ShotClock";

export default function ShotClockAction({ load, setAvailableToBook, active, actionCallback }) {
  return (
    <ShotClock
      load={load}
      type="table"
      setAvailableToBook={setAvailableToBook}
      active={active}
      actionCallback={actionCallback}
    />
  );
}

ShotClockAction.propTypes = {
  load: PropTypes.object.isRequired,
  setAvailableToBook: PropTypes.func.isRequired,
  active: PropTypes.bool,
  actionCallback: PropTypes.func.isRequired
};